<template>
    <el-popover
        placement="right"
        width="400"
        trigger="click"
        >
        <div 
            v-html="priceDescribe"
            class="referenceContent"
            >
        </div>
        <span 
            class="reference"
            slot="reference"
            >
            <i class="el-icon-warning"></i> 说明
        </span>
    </el-popover>
</template>
<script>

export default {
    props: {
        priceDescribe: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            loading: false,
            result: {}
        }
    },
    methods: {
    },
    created() {
    },
    mounted() {
    },
}
</script>

<style scoped>
    .referenceContent {
        max-height: 400px;
        overflow: auto;
    }

    .reference {
        display: inline-block;
        cursor: pointer;
        color: #3D7EFF;
    }
</style>